import {Component, Input, OnInit} from '@angular/core';
import {ApiService, UserInfo} from "../../services/api.service";
import {TranslateService} from "@ngx-translate/core";
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-badge-status',
    templateUrl: './badge-status.component.html',
    styleUrl: './badge-status.component.scss',
    imports: [CommonModule],
    standalone: true,
})
export class BadgeStatusComponent {
    circleColor: string
    statusColor: string = '#1B9C67'
    // 1B9C67
    // F53000
    // FFC700
    @Input() statusText: string
    @Input() sectionClass: string = ''
    @Input() iconClass: string = 'claim rejected'

    constructor(
        private api: ApiService,
        private translate: TranslateService,
    ) {}
}
